import { DealStateEnum } from '../gql/dealGql';

const {
  Estimate,
  SoftClose,
  StructuringInProgress,
  Structuring,
  Closing,
  Closed,
  SentForSignatures,
  Signed,
  Funded,
  SendPayoff,
  WaitingForTitle,
  TitleReceived,
  SentToProcessor,
  Finalized,
} = DealStateEnum;

// T0DO: Use this instead of DealStateEnum
// const BuyoutDealStatesInOrder = {
//   Estimate: 'estimate',
//   SoftClose: 'soft_close',
//   StructuringInProgress: 'structuring_in_progress',
//   Structuring: 'structuring',
//   Closing: 'closing',
//   Closed: 'closed',
//   SentForSignatures: 'signatures',
//   Signed: 'signed',
//   Funded: 'funded',
//   SendPayoff: 'send_payoff',
//   WaitingForTitle: 'waiting_for_title',
//   TitleReceived: 'title_received',
//   SentToProcessor: 'sent_to_processor',
//   Finalized: 'finalized',
//   Booted: 'booted',
// } as const;

// Used to determine which state to revert to when the user clicks the "set to <previous state>" button
export const BuyoutDealPreviousStateMap: Partial<Record<DealStateEnum, DealStateEnum>> = {
  [Closing]: Structuring,
  [Closed]: Closing,
  [SentForSignatures]: Closed,
  [Signed]: Closed,
  [Funded]: Signed,
  [WaitingForTitle]: SendPayoff,
  [TitleReceived]: WaitingForTitle,
  [SentToProcessor]: TitleReceived,
};

export const TITLING_STATES = [
  Signed,
  Funded,
  SendPayoff,
  WaitingForTitle,
  TitleReceived,
  SentToProcessor,
  Finalized,
];

// States that show Titling Info on Deal Details page
const DEFAULT_TO_TITLE_INFO_STATES = [WaitingForTitle, TitleReceived, SentToProcessor, Finalized];

const IS_FUNDED_STATES = [
  Funded,
  Finalized,
  SendPayoff,
  WaitingForTitle,
  TitleReceived,
  SentToProcessor,
];

export const CLOSED_DEAL_STATES = [Closed, SentForSignatures, Signed, ...IS_FUNDED_STATES];

const BEFORE_CLOSING_STATES = [Estimate, SoftClose, StructuringInProgress, Structuring];

// keep in sync with backend: types/deal.ts
const UNEDITABLE_DEAL_STATES = [
  Closed,
  SentForSignatures,
  Signed,
  Funded,
  Finalized,
  SendPayoff,
  WaitingForTitle,
  TitleReceived,
  SentToProcessor,
];

export const isBeforeClosing = (state: DealStateEnum) => BEFORE_CLOSING_STATES.includes(state);
export const isClosed = (state: DealStateEnum) => CLOSED_DEAL_STATES.includes(state);
export const isDealInOrPastFunded = (state: DealStateEnum) => IS_FUNDED_STATES.includes(state);
export const isTitling = (state: DealStateEnum) => TITLING_STATES.includes(state);
export const shouldDefaultToTitleInfo = (state: DealStateEnum) =>
  DEFAULT_TO_TITLE_INFO_STATES.includes(state);

export const isUneditable = (state?: DealStateEnum) =>
  !!state && UNEDITABLE_DEAL_STATES.includes(state);
